const GENERICO = 'Ocurrió un error inesperado. Intente de nuevo más tarde.'
const CARGARDATOS = 'Error al procesar los datos. Intente de nuevo.'
const SUBIRDATOS = 'Falló la conexión con el servidor. Reintente.'

export default {
  GENERICO,
  CARGARDATOS,
  SUBIRDATOS
}



// WEBPACK FOOTER //
// ./src/utils/errores_genericos.js